<template>
  <v-card flat>
    <v-row>
      <v-col cols="12" md="6">
        <h2>{{ $t(title) }}</h2>
      </v-col>
      <v-col cols="12" md="6" class="text-right">
        <v-btn
          v-for="btn in customButtonList"
          outlined
          color="primary"
          :key="`btn_${btn.id}`"
          @click="clickButton(btn)"
          class="ml-1"
          v-permission="usePermission ? [btn.id] : []"
        >
          <v-icon>{{ btn.icon }}</v-icon>
          {{ btn.text }}
        </v-btn>
        <v-btn
          v-for="btn in buttonList"
          outlined
          color="primary"
          :key="`btn_${btn.id}`"
          @click="clickButton(btn)"
          class="ml-1"
          v-permission="usePermission ? [btn.id] : []"
        >
          <v-icon>{{ btn.icon }}</v-icon>
          {{ btn.text }}
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import i18n from '@/i18n'
import store from '@/store'
import DispatchResize from '@/mixins/DispatchResize'
export default {
  name: 'PageHeader',
  props: {
    type: {
      type: String,
      default: 'white-list'
    },
    title: {
      type: String,
      default: () => {
        return i18n.t(store.state.log.menuId)
      }
    },
    useList: {
      type: Array,
      default: () => ['btnSearch', 'btnCreate', 'btnUpdate', 'btnDelete']
    },
    usePermission: {
      type: Boolean,
      default: false
    },
    customButtonList: {
      type: Array,
      default: () => []
    }
  },
  created() {
    // Object 값으로 들어온 버튼 정보를 취합되는 배열
    let objectButtons = []
    // 사용 여부를 판별하기 위한 대조군 배열 구성
    let contrastIds = this.useList.map(use => {
      if (typeof use === 'string') return use
      if (typeof use === 'object' && use.id) {
        objectButtons.push(use)
        return use.id
      }
    })
    // 기본 셋에서 사용 여부를 판별하기 위한 대조군 배열을 비교하여 재 구성
    let manfList = this.buttonList.filter(btn => {
      if (this.type === 'black-list') {
        // type 값이 blak-list일 경우 useList 부여된 button 들은 사용하지 않는다.
        return !contrastIds.includes(btn.id)
      } else if (this.type === 'white-list') {
        // default 값. type 값이 white-list일 경우 useList 부여된 button 들은 사용한다.
        return contrastIds.includes(btn.id)
      }
      return false
    })
    // object로 부여 받은 useList는 기본 셋에 Assign 한다.
    objectButtons.forEach(btn => {
      Object.assign(_.find(manfList, { id: btn.id }), btn)
    })
    // 사용되는 값을 기준으로 정렬한다.
    let printSet = []
    contrastIds.forEach(id => {
      printSet.push(_.find(manfList, { id }))
    })
    // 구성된 버전을 실제 대입
    this.buttonList = printSet
    // this.dispatchResize()
  },
  mixins: [DispatchResize()],
  data() {
    return {
      /**
       * 버튼 기본셋을 정의합니다.
       * id 값은 이벤트 정의된 키 값이며, 이 값으로 제어 처리 및 이벤트를 발생합니다.
       * text 값은 버튼에 Label로 출력될 값입니다.
       * icon은 버튼 Label 왼쭉에 출력될 아이콘을 의미하며, 'https://element.eleme.io/2.6/#/en-US/component/icon'를 참고바랍니다.
       */
      buttonList: [
        { id: 'btnSearch', text: '조회', icon: 'mdi-magnify' },
        { id: 'btnCreate', text: '저장', icon: 'mdi-check' },
        { id: 'btnUpdate', text: '수정', icon: 'mdi-pencil-outline' },
        { id: 'btnDelete', text: '삭제', icon: 'mdi-minus' },
        {
          id: 'btnImport',
          text: 'import',
          icon: 'mdi-file-document-edit-outline'
        },
        {
          id: 'btnExport',
          text: 'Export',
          icon: 'mdi-file-document-edit-outline'
        },
        { id: 'btnPrint', text: '출력', icon: 'mdi-printer' },
        { id: 'btnCopy', text: '복사', icon: 'mdi-content-copy' },
        { id: 'btnBundleCreate', text: '일괄등록', icon: 'el-icon-tickets' },
        { id: 'btnCustom3', text: '커스텀3', icon: 'el-icon-tickets' },
        { id: 'btnCustom4', text: '커스텀4', icon: 'el-icon-tickets' },
        { id: 'btnCustom5', text: '커스텀5', icon: 'el-icon-tickets' },
        { id: 'btnCustom6', text: '커스텀6', icon: 'el-icon-tickets' },
        { id: 'btnCustom7', text: '커스텀7', icon: 'el-icon-tickets' },
        { id: 'btnCustom8', text: '커스텀8', icon: 'el-icon-tickets' }
      ]
    }
  },
  methods: {
    clickButton(targetButton) {
      this.$emit(targetButton.id)
    }
  }
}
</script>

<style scoped>
</style>
